import { BadgeColors } from "../../shared-components/Badge";

export enum ReportEntryStyle {
  TOOLTIP = "TOOLTIP",
  TEXT = "TEXT",
  BOLD_TEXT = "BOLD_TEXT",
  BADGE = "BADGE",
  CANCEL = "CANCEL",
  COMPONENT = "COMPONENT",
  ROOT_COMPONENT = "ROOT_COMPONENT",
}

export interface ReportEntry {
  text: string;
  style: ReportEntryStyle;
  badgeColor?: BadgeColors;
  component?: JSX.Element;
  customClass?: string;
}

export interface ReportRowItem<T> {
  report_uuid: string;
  report?: T;
  data: ReportEntry[];
  isLocked?: boolean;
}
